import { SelectV2, SelectV2Option } from '@cimplico/components';
import { useEffect, useState } from 'react';
import { JournalTaxTypeEnum } from '../../types/journal';

type JournalTaxTypeSelectProps = {
    value?: JournalTaxTypeEnum | null;
    errorMessage?: string;
    disabledHint?: string;
    isDisabled?: boolean;
    onChange: (type: JournalTaxTypeEnum | null) => void;
};

function JournalTaxTypeSelect({ value, errorMessage, disabledHint, isDisabled, onChange }: JournalTaxTypeSelectProps): JSX.Element {
    const [selected, setSelected] = useState<SelectV2Option[]>([]);
    const [search, setSearch] = useState('');

    function handleJournalTaxTypeChange(options: SelectV2Option[]): void {
        onChange(options.length === 0 ? null : (options[0].value as JournalTaxTypeEnum));
    }

    const options: { [key: string]: JournalTaxTypeEnum } = {
        'Tax Exclusive': JournalTaxTypeEnum.EXCLUSIVE,
        'Tax Inclusive': JournalTaxTypeEnum.INCLUSIVE,
        'No Tax': JournalTaxTypeEnum.NO_TAX,
    };

    useEffect(() => {
        setSelected(value ? [{ label: Object.keys(options).find((key) => options[key] === value) as string, value }] : []);
    }, [value]);

    return (
        <div className="min-w-[150px]">
            <SelectV2
                size="small"
                placeholder="Amounts are..."
                keepSelectedOptions
                onSearch={setSearch}
                errorMessage={errorMessage}
                value={selected}
                disabled={isDisabled}
                disabledHint={disabledHint}
                onChange={handleJournalTaxTypeChange}
                borderStyle="underline"
                options={Object.keys(options)
                    .filter((opt) => opt.toLowerCase().includes(search.toLowerCase()))
                    .map((option) => {
                        return { label: option, value: options[option] };
                    })}
            />
        </div>
    );
}
export default JournalTaxTypeSelect;
